import React from 'react';
import { useBrandKit } from '../context/BrandKitContext';
import BrandLogo, { BrandWordmark } from './BrandLogo';

/**
 * Loading indicator using the product logo with a yellow fill-from-bottom animation.
 * White-label kits swap the IPM mark for the client logo.
 */
const LogoLoading = ({ message = 'Loading...', style = {}, className = '' }) => {
    const { active, hideIpm, productName } = useBrandKit();
    const fillStyle = active
        ? { filter: 'none' }
        : undefined;
    return (
    <div
        className={`logo-loading${className ? ` ${className}` : ''}`}
        style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '16px',
            minHeight: '120px',
            color: '#64748b',
            fontFamily: "var(--brand-font, 'Poppins', sans-serif)",
            fontSize: '14px',
            ...style
        }}
    >
        <div className={`logo-loading__logo-wrap${hideIpm ? ' logo-loading__logo-wrap--mark' : ''}`}>
            <div className="logo-loading__base" aria-hidden>
                <BrandLogo className="logo-loading__img" />
                {!hideIpm && <BrandWordmark className="logo-loading__text" />}
            </div>
            <div className="logo-loading__fill" aria-hidden>
                <BrandLogo className={`logo-loading__img${active ? '' : ' logo-loading__img--yellow'}`} style={fillStyle} />
                {!hideIpm && <BrandWordmark className="logo-loading__text logo-loading__text--yellow" />}
            </div>
        </div>
        {message && <span>{message === 'Loading...' && active ? `Loading ${productName}…` : message}</span>}
    </div>
    );
};

/** Fill-up mark over Adash while cards breathe (`is-warming`). */
export function AdashWarmLogo({ show }) {
    if (!show) return null;
    return (
        <div className="adash__warm-logo-slot" data-pdf-exclude>
            <div className="adash__warm-logo">
                <LogoLoading message="Loading..." style={{ minHeight: 0 }} />
            </div>
        </div>
    );
}

export default LogoLoading;
